import "./Status.scss";
import { IoWalletOutline } from "react-icons/io5";
import succrow from "../../Assets/successarrow.png";
import { useState } from "react";
const cardsData = [
  {
    title: "ALLPAYMENTS",
    percentage: "4% (This Week)",
    number: "93.155",
    iconColor: "#23cebc",
    numberColor: "#006ed3",
  },
  {
    title: "SUUCCEFUL",
    percentage: "7.2% (This Week)",
    number: "120.000",
    iconColor: "#23cebc",
    numberColor: "#006ed3",
  },
  {
    title: "PENDING",
    percentage: "9.5% (This Week)",
    number: "34.200",
  iconColor: "#23cebc",
    numberColor: "#006ed3",
  },
    {
    title: "DECLINED",
    percentage: "9.5% (This Week)",
    number: "34.200",
  iconColor: "#23cebc",
    numberColor: "#006ed3",
  },
    {
    title: "REFUNDED",
    percentage: "9.5% (This Week)",
    number: "34.200",
    iconColor: "#23cebc",
    numberColor: "#006ed3",
  },
    {
    title: "CANCELED",
    percentage: "9.5% (This Week)",
    number: "34.200",
    iconColor: "#23cebc",
    numberColor: "#006ed3",  },

];

export default function Status() {
    //    const [open, setOpen] = useState(null);

  return (
    <div className="all-status   ">
        <div className="d-flex align-items-center justify-content-around">
     {cardsData.map((card, index) => (
        <div className="card-box" key={index}>
          <h6 style={{ color: "#0085ff", marginBottom: "30px" }}>{card.title}</h6>

          <div
            className="d-flex align-items-center gap-2"
            style={{
              marginLeft: "14px",
              marginBottom: "20px",
            }}
          >
            <span className="cover-img">
              <img src={succrow} alt="succrow" width={7} />
            </span>
            <span style={{ color: "#a3a3a3" }}>{card.percentage}</span>
          </div>

          <div className="numbers d-flex align-items-center gap-2">
            <IoWalletOutline style={{ fontSize: "26px", color: card.iconColor }} />
            <div className="line"></div>
            <h4
              style={{
                fontWeight: "bold",
                color: card.numberColor,
                fontSize: "32px",
              }}
            >
              {card.number}
            </h4>
          </div>
        </div>
      ))}

        </div>
 
     {/* <div className="product-headerr" onClick={() => setOpen(open === "Time" ? null : "Time")}>
                      This week
                      <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {open === "Time" && (
                        <div className="list-body">
                          <ul className="list">
                            <li>All Time</li>
                            <li>24 Hours</li>
                            <li>30 Days</li>
                            <li>3 Months</li>
                            <li>6 Months</li>
                            
                          </ul>
                        </div>
                      )}
                    </div> */}
    </div>
  );
}
